// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"0a6b1111","71":"ec6bcf42","249":"05eb42a3","791":"200c5ece","886":"3caa41dc"}[chunkId] + ".js";
};